<template>
  <base-modal
    hideFooter
    :size="'lg'"
    @hidden="$emit('onCloseModal')"
    @show="onModalOpen"
    :modalId="'campaign-create'"
  >
    <template #modal-header>
      <div class="head-label">
        <b>{{ containerId == null ? "Add Campaign" : "Edit Campaign" }}</b>
      </div>
    </template>
    <b-form id="campaign-create-modal" @submit.prevent="onSubmit">
      <b-row>
        <b-col cols="12 px-2">
          <b-row class="">
            <b-col cols="12" md="6">
              <div class="d-flex">
                <span class="status-toggle">{{ "Status" }} </span>
                <b-form-checkbox
                  fieldValue="true"
                  class="custom-control-success custom-toggle"
                  name="check-button"
                  switch
                  v-model="form.status"
                  :disabled="containerId == null"
                >
                  <span class="switch-icon-left toggle-text">{{
                    "Active"
                  }}</span>
                  <span class="switch-icon-right toggle-text">{{
                    "Inactive"
                  }}</span>
                </b-form-checkbox>
              </div>
            </b-col>
          </b-row>
          <div class="d-flex align-items-end w-100 mb-2">
            <div class="campaign-label">Campaign Name</div>
            <b-form-input
              class="w-70"
              id="name-inventory"
              placeholder="Campaign Name"
              required
              v-model="form.name"
            />
          </div>
        </b-col>
        <b-col cols="12">
          <div class="privilege-btn-wrp mt-2">
            <div class="d-flex justify-content-center">
              <cancel-button
                class="mr-1"
                @click.native="$emit('onCloseModal')"
              />
              <save-button :type="'submit'" class="ml-1" :loading="loading.btn" />
            </div>
          </div>
        </b-col>
      </b-row>
    </b-form>
    <b-row class="modal-body-container mb-1"> </b-row>
  </base-modal>
</template>

<script>
import BaseModal from "@/@core/components/base-modal/BaseModal.vue";
import Toggle from "@/views/components/dynamic-fields/components/ToggleFields.vue";
import useCampaignCreateModal from "../hooks/useCampaignCreateModal";
import {
  BForm,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BFormCheckbox,
} from "bootstrap-vue";
export default {
  components: {
    BForm,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BFormCheckbox,
    BaseModal,
    Toggle,
  },
  props: {
    containerId: { type: Number },
  },
  setup(props) {
    // const {
    //   onModalOpen,
    //   form,
    //   statusProperty,
    //   onToggleStatus,
    // } = useDocumentList(); // remove

    const { loading, form, onModalOpen, onSubmit } = useCampaignCreateModal(
      props
    );
    return {
      loading,
      form,
      onModalOpen,
      onSubmit,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/document-detail/campaign-create.css";
</style>
